@if (showTotalPointsContainer) {
  <div class="total-points-container-task-bar">
    <div class="total-points-container" [style]="{'background-color': totalPointsBackgroundColor + ' ', 'border-color': totalPointsBorderColor + ' '}">
      <div class="total-points-label-container">
        <p class="total-points-score-task font-20">{{totalPoints() | number}}</p>
        <p class="total-points-label-task font-11">TASK POINTS</p>
      </div>
    </div>
  </div>
}